import axios from "axios";

// baseURL "/api" — the frontend server.js (or setupProxy in dev) reverse-proxies
// /api, /socket.io and /public to the backend, so the image is origin-agnostic.
const api = axios.create({
  baseURL: "/api",
  withCredentials: true, // send the httpOnly refresh cookie on /auth/refresh
});

export default api;
